<template>
    <div>
        <b-modal id="modal-remote-area" hide-header hide-footer>
            <div class=" text-center" style="
                    display: flex;
                    flex-direction: column;
                    align-items: center; ">
                <div class="border " style=" border-radius: 50%;
                    width: 110px;
                    height: 110px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #0b9dd1">
                    <i class="fas fa-money-bill-wave" style="
                    font-size: 50px;
                    color: white; "></i>
                </div>
                <template v-if="remoteArea.rate > 0">
                <h3 class="mt-3 mb-0">รายการนี้ อยู่ใน<span class="text-danger">พื้นที่คิดค่าบริการพิเศษ</span> <span class="display-1"> {{remoteArea.rate}} </span> บาท</h3>
                </template>
                <template v-if="crossPrice > 0">
                <h3 class="mt-3 mb-0">รายการนี้ <span class="text-danger">มีค่าบริการส่งข้ามภาค</span> 
                <span class="display-1"> {{crossPrice}} </span> บาท</h3>
                </template>
                <p class="secondary">( กรุณาแจ้งค่าบริการพิเศษนี้ให้ลูกค้าทราบ)</p>
            </div>
            <hr class="p-0 m-0 mb-2">
            <b-button variant="primary" class="float-right" @click="$bvModal.hide('modal-remote-area')">ปิด</b-button>
        </b-modal>
    </div>
</template>

<script>
export default {
    name:'ModalAlertRemoteArea',
    props:{
        remoteArea: Object,
        crossPrice: Number
    },
}
</script>